import { Product } from '@api/catalog/products/products.models';

export interface CmsRenderState{
    pages?: Record<string, any>;
    statusPage: Record<string, RenderStatus>;
    products?: Product[];
    sectionFocused?: { id: string; theme: string };
    theme?: CmsThemePage;
    titleSection?: string;
}

export interface RenderStatus {
    status: string;
    showCountdown?: boolean;
}

export enum CmsThemePage {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
    BLEND = 'BLEND',
    NO_LOGO = 'NO_LOGO',
}

export const cmsRenderState: CmsRenderState = {
    pages: {},
    products: [],
    statusPage: {},
    sectionFocused: { id: null, theme: null },
};
